module.exports = __webpack_public_path__ + "img/android.c2757619.svg";